import { Pipe, PipeTransform } from '@angular/core';
import { ShipmentStatus } from '@shared/service-proxies/service-proxies';

@Pipe({ name: 'shipmentStatus' })
export class ShipmentStatusPipe implements PipeTransform {

    transform(status: number): string {
        if (status === undefined || status === null) {
            return '';
        }

        switch (status) {
            case ShipmentStatus.Expected: return 'Expected';
            case ShipmentStatus.Loaded: return 'Loaded';
            case ShipmentStatus.Transfer: return 'Transfer';
            case ShipmentStatus.Receiving: return 'Receiving';
            case ShipmentStatus.Loading: return 'Loading';
            case ShipmentStatus.InProcess: return 'In Process';
            case ShipmentStatus.Suspended: return 'Suspended';
            case ShipmentStatus.Ready: return 'Ready';
            case ShipmentStatus.Staged: return 'Staged';
            case ShipmentStatus.CheckedIn: return 'Checked In';
            case ShipmentStatus.Closed: return 'Closed';
            case ShipmentStatus.Complete: return 'Complete';
            case ShipmentStatus.Cancelled: return 'Cancelled';
            default: return 'Unknown';
        }
    }
}
